import React, { useEffect, useState } from 'react';
import { Table, Button, Card, Spinner, Row, Col, Alert } from "react-bootstrap";
import { Form, Field } from "react-final-form";
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

//Actions
import { pesquisacompedido as pesquisatodos } from '../../../../actions/credenciamento/credencial';
import { notificacaoemail } from '../../../../actions/html/modelos';
import { campotexto, camporadio } from '../../../../components/forms/campos/campos';

import { getMsgAlertStatusPedido } from '../../../../helpers/StatusPedidosAlert';
import { getEvento } from '../../../../utils/eventosession';

const PesquisaCongresso = (props) => {

    const [evento,setEvento] = useState({});
    const [credenciais,setCredenciais] = useState([]);
    
    const handleCarregaPesquisa = async (form) => {        
        const params = {
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            ...form
        }
        
        setCredenciais(await props.pesquisatodos({
            ...params
        }));
    }

    const handleSubmitCredenciais = async (form) => {

        const params = {
            idpromotora: evento.idpromotora,
            idevento: evento.idevento,
            tipo: 'EMAIL_PENDENCIAS'
        }

        console.log(form.idfisica);
        for(let i=0;i<=form.idfisica.length;i++){
            if(form.idfisica[i]){                
                await props.notificacaoemail({...params, idfisica: form.idfisica[i]});
            }
        }        
    }
        
    useEffect(() => {
        setEvento(getEvento());
    },[props.eventoSelecionado]);

    return (
        <>
        <Form
        onSubmit={handleCarregaPesquisa}        
        render={({form, submitting, handleSubmit}) => {
            return (
                <form onSubmit={handleSubmit}>
                    <Card className="mb-2">
                        <Card.Header>Pesquisar Credencial Com Pedidos</Card.Header>
                        <Card.Body>
                            <Row>
                                <Col>
                                    <Field type='checkbox' label="Pedidos Vencidos" name="pedidosvencidos" value={true} component={camporadio} />
                                </Col>
                            </Row>
                            <Row>                                
                                <Col>
                                    <Field label="Nome" name="nome" placeholder="Pesquisa por nome" component={campotexto} />
                                </Col>
                                <Col>
                                    <Field label="E-mail" name="email" placeholder="Pesquisa por e-mail" component={campotexto} />
                                </Col>                                
                                <Col>
                                    <Button type="submit" className="mt-4" block disabled={submitting}>{submitting?<Spinner animation="border" />:"Pesquisar"}</Button>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>                
                </form>
            );
        }}
        />
        <Form
        onSubmit={handleSubmitCredenciais}
        validate={(form) => {
            const errors = {};            
            return errors;
        }}
        render={({form, submitting, handleSubmit}) => {
            return (
                <form onSubmit={handleSubmit}>                
                    <Table striped bordered hover>
                        <thead>
                            <tr>
                            <th>Nome</th>
                            <th>E-mail</th>
                            <th>CPF</th>
                            <th>Vencimento</th>
                            <th>Status Pedido</th>
                            <th>Selecionar</th>
                            </tr>
                        </thead>
                        <tbody>
                            {credenciais.length?credenciais.map((itens, index)=> {
                                return (
                                    <tr key={index}>
                                        <td>{itens.fisica.nome+' '+itens.fisica.sobrenome}</td>
                                        <td>{itens.fisica.email}</td>
                                        <td>{itens.fisica.cpf}</td>
                                        <td>
                                            {itens.pedido===null?
                                                null
                                                :
                                                itens.pedido.vencto
                                            }                                        
                                        </td>
                                        <td>
                                            {itens.pedido===null?
                                                <Alert variant='info'>Sem Pedido</Alert>
                                                :
                                                getMsgAlertStatusPedido(itens.pedido).msg
                                            }                                        
                                        </td>
                                        <td>
                                            {itens.pedido===null?
                                            'Sem Pedido'
                                            :
                                            (itens.pedido.idstatus!==2?
                                            <Field type='checkbox' name="idfisica" value={itens.idfisica} component={camporadio} />
                                            :
                                            null
                                            )}
                                        </td>
                                    </tr>
                                );
                            }):submitting?"":<tr><td colSpan="6"><Alert variant="warning" block>Nenhum resultado para mostrar</Alert></td></tr>}                
                        </tbody>
                    </Table>
                    {credenciais.length?
                    <Button type="submit" className="mt-4" block disabled={submitting}>{submitting?<Spinner animation="border" />:"Enviar E-mail"}</Button>
                    :
                    null
                    }
                </form>
            );
        }}
        />     
        </>   
    )
}

const mapStateToProps = (state) => {
    return {
        pendingTasks: state.pendingTasks,
        eventoSelecionado: state.reducerEventoSelecionado
    }
}

export default connect(mapStateToProps,{pesquisatodos,notificacaoemail})(withRouter(PesquisaCongresso));